import { CommonStateEnum } from "./common";
import { Org } from "./org";
import { User } from "./user";

export interface ReimburseCategoryAdd {
  code: string;
  name: string;
  desc: string;
  sortOrder: number;
}

export interface ReimburseCategory {
  id: string;
  code: string;
  name: string;
  desc: string;
  rootId: string;
  path: string;
  level: number;
  sortOrder: number;
  subs: ReimburseCategory[] | null;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  pid: string | null;
  useState: CommonStateEnum;
}

export enum ApplicationTypeEnum {
  REIMBURSEMENT = 1,    //报销申请
  DAILY_SUPPLIES = 2,    //日常用品申请
  MATERIAL_OVER_ISSUE = 3,    //超领领料申请
}

export enum ApproveTypeEnum {
  IN_ORDER = 1,       //按照顺序审批/每一步都同意=同意
  ANY = 2,            //任意一步都同意=同意
  LAST = 3            //最后一步都同意=同意
}

export enum AssignTypeEnum {
  SPECIFIC_ORG_ANYONE = 1,       //指定组织任何人
  APPLICANT_ORG_ANYONE = 2,       //申请人组织任何人
  SPECIFIC_USERS = 3            //选定多个人
}
export interface ApproveStep {
  id: string;
  templateId: string;
  approveDays: number | null;
  stepNo: number;
  assignType: AssignTypeEnum;
  assignOrgId: string;
  assignOrg: Org | null;
  assignUsers: Array<User> | null;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
}
export interface Approve {
  id: string;
  name: string;
  applicationType: ApplicationTypeEnum;
  description: string;
  approveType: ApproveTypeEnum;
  steps: Array<ApproveStep>;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
};

export interface ApproveStepSet {
  stepNo: number;
  assignType: AssignTypeEnum;
  assignOrgId: string;
  assignUserIds: Array<string>;
  approveDays: number;
}
export interface ApproveSet {
  approveType: ApproveTypeEnum;
  name: string;
  applicationType: ApplicationTypeEnum;
  description: string;
  steps: Array<ApproveStepSet>
}


export enum ApproveStatusEnum {     //申请状态
  DRAFT = 0,        //草稿
  PENDING = 1,      //带审批
  APPROVED = 2,     //已审批
  RETURNED = 3,     //已拒绝
  REJECTED = 4      //已退回
}


export enum ApproveStepStatusEnum {     //步骤审批状态
  PENDING = 1,      //带审批
  APPROVED = 2,     //已审批
  RETURNED = 3,      //已拒绝
  REJECTED = 4,     //已退回
}

export interface ReimbursRequestStep {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  sequence: number;
  applicationId: string;
  templateId: string;
  stepNo: number;
  assignType: AssignTypeEnum;
  assignOrgId: string | null;
  stepStatus: ApproveStepStatusEnum;
  approverId: string | null;
  approvalComment: string | null;
  approvalAt: number | null;
  candidates: Array<User> | null;
  org: Org | null;
}

export interface RequestReimbursementItem {
  id: string;
  applicationId: string;
  categoryId: string;
  amount: number;
  expenseDate: number;
  description: string | null;
  invoiceCount: number;
  remark: string | null;
  docId: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
}
export interface RequestReimbursement {
  id: string;
  applicationId: string;
  totalAmount: number;
  remark: string;
  currency: string;
  items: Array<RequestReimbursementItem>;
}

export interface RequestDailyItem {
  applicationId: string;
  count: number;
  createdAt: number;
  createdBy: string;
  desc: string;
  docId: string;
  id: string;
  productCode: string;
  productName: string;
  productModel: string;
  state: CommonStateEnum;
  updatedAt: number;
  updatedBy: string;
}
export interface RequestDaily {
  id: string;
  applicationId: string;
  purpose: string;
  remark: string;
  items: Array<RequestDailyItem>
}
export interface ReimbursRequest {
  id: string;
  number: string;
  type: ApplicationTypeEnum;
  applicantId: string;
  orgId: string;
  status: ApproveStatusEnum;
  title: string;
  content: string;
  logbookId: string;
  dirId: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  sequence: number;
  submitAt: number | null;
  completeAt: number | null;
  approveType: ApproveTypeEnum | null;
  reimbursement: RequestReimbursement | null;
  dailySupplies: RequestDaily | null;
  steps: Array<ReimbursRequestStep> | null;
  creator: User;
  updater: User;
  org: Org;
}

export interface AddDailyRequestItem {
  productCode: string;
  productName: string;
  productModel: string;
  count: number;
  desc: string;
  docId?: string;
}
export interface AddDailyRequest {
  title: string;
  content: string;
  purpose: string;
  remark: string;
  items: Array<AddDailyRequestItem>
  dirId?: string | null;
}

export interface AddReimburseRequestItem {
  categoryId: string;
  amount: number;
  expenseDate: number;
  description: string;
  invoiceCount: number;
  remark: string;
  docId?: string;
}
export interface AddReimburseRequest {
  title: string;
  content: string;
  totalAmount: number;
  remark: string;
  items: Array<AddReimburseRequestItem>;
  currency?: string | number;
  dirId?: string | null;
}

//超领申请

export enum OverIssueReasonTypeEnum {
  MISTAKE = 1, //失误
  WASTE = 2, //浪费
  OTHER = 3, //其他
}

export interface AddMoiRequestItem {
   requirementItemId: string; // 需求单明细ID
  productId: string;         // 物料ID
  overCount: number;                // 本次超领数量(必须>0)
  reasonType: OverIssueReasonTypeEnum;               // 超领原因枚举 (1=失误 2=浪费 3=其他)，详见OverIssueReasonType
  reason: string;   // 详细说明(多语言长文本)
}

export interface AddMoiRequest {
  id: string | null;           // 申请ID (空=新建, 非空=编辑)
  title: string;         // 申请标题
  content: string;      // 申请说明
  requirementId: string; // 关联需求单ID
  items: Array<AddMoiRequestItem>;
}

export interface MoiItem {
  id: string;
  applicationId: string; // 申请ID
  requirementId: string; // 关联需求单ID
  requirementItemId: string; // 需求单明细ID
  productId: string; // 物料ID
  orderAmount: number; // 额度(应领数量)
  outCount: number; // 申请时已领数量
  overCount: number; // 本次超领数量
  reasonType: OverIssueReasonTypeEnum; // 超领原因枚举 (1=失误 2=浪费 3=其他)
  reason?: string | null; // 详细说明
  picked: number; // 是否已生成出库单(0=否 1=是)
}

export interface MoiReimbursRequest {
  application: ReimbursRequest; // 申请主表，type=3
  items: Array<MoiItem>; // 超领明细列表
}
